module.exports = __webpack_public_path__ + "img/notice-ch.c7d25384.png";